import { UserMgr } from './mgrs/UserMgr';
import { LoginMgr } from './mgrs/LoginMgr';
import { AppConfig } from '../AppConfig';

export class Controller {
  static _me = null;
  static get() {
    if (this._me == null) {
      this._me = new Controller();
    }
    return this._me;
  }

  constructor() {
  }

  _loginMgrObj = null;
  loginMgr() {
    if (null == this._loginMgrObj) {
      this._loginMgrObj = new LoginMgr();
    }
    return this._loginMgrObj;
  }

  _userMgrObj = null;
  userMgr() {
    if (null == this._userMgrObj) {
      this._userMgrObj = new UserMgr();
    }
    return this._userMgrObj;
  }

  getUserId() {
    //return this.userMgr().getUserId()
    const cognitoUser = Controller.get().loginMgr().getCurrentUser()
    if (cognitoUser) {
      return cognitoUser.username
    }
    return null;
  }

  setNavigator(history) {
    this.history = history
  }

  pushRoute(route) {
    this.history.push(route)
  }

  pushRouteWithParams(route, params) {
    this.history.push({ pathname: route, state: params })
  }

  pushToHome() {
    this.pushRoute(Controller.get().getHomeByRole())
  }

  logout() {
    console.log('logout');
    this.loginMgr().signOut();
    this.pushRoute('/')
  }

  getHomeByRole() {
    if (Controller.get().userMgr().isProductSU()) {
      return '/admin'
    } else {
      const appUser = Controller.get().userMgr().getAppUser()
      if(!appUser) {
        return '/login'
      }
      if(!appUser.state ||
        appUser.state !== 'READY') {
        return AppConfig.clientProfile
      }
      return AppConfig.clientDashboard
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/Controller.js